module.exports = __webpack_public_path__ + "static/media/male-green-v3.4bb3043a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/male-green-v3.svg
// module id = 71
// module chunks = 0